<button
  bitIconButton="bwi-trash"
  buttonType="danger"
  size="small"
  type="button"
  class="tw-border-transparent"
  [label]="'deleteAttachmentName' | i18n: attachment.fileName"
  [bitAction]="delete"
></button>
